import { useSelector } from "react-redux";
import type { ApplicationState } from "../../../../../../store";
import { FilterState } from "../type";

export const useFilterState = (): FilterState | undefined => {
  return useSelector((state: ApplicationState) => 
    state.GamificationFilter
  );
};
